export interface LeaveConfirmationInput {
    hasUnsavedChanges: boolean;
    message: string;
    confirm: (message: string) => boolean;
}

export interface BlockableHistory {
    block: (message: string) => () => void;
}

export interface NavigationBlocker {
    release: () => void;
}

export const NO_NAVIGATION_BLOCKER: NavigationBlocker = { release: () => { } };

export function confirmLeaveWithUnsavedChanges({ hasUnsavedChanges, message, confirm }: LeaveConfirmationInput): boolean {
    if (!hasUnsavedChanges) return true;
    return confirm(message);
}

export function createNavigationBlocker(history: BlockableHistory, message: string): NavigationBlocker {
    let unblock: (() => void) | null = history.block(message);

    return {
        release: () => {
            if (unblock == null) return;
            unblock();
            unblock = null;
        }
    };
}
